export enum FrameRequestMappedStatuses {
    // Предстоящ
    Upcoming = 2,
    // Обработка
    Processing = 3,
    // Изпълнен
    Fulfilled = 4,
    // Проверка
    Checking = 5,
    // Завършени
    Completed = 6,
    // Разпечатване
    Printout = 7,
    // Посещение
    Visit = 8,
    // Рекламации
    Complaints = 9,
    // Доставяне
    Delivery = 10,
    // Върнат
    Returned = 11,
    // Измерен
    Measured = 12,
    // Неприложим
    Inapplicable = 13,
    // Разпределение
    Distribution = 14,
    // Нов
    New = 16,
    // Неуспешен
    Unsuccess = 17,
    // Успешен
    Success = 18,
    // Одобрен
    Approved = 19,
    // Заключен
    Locked = 20,
    // Подписан
    Signed = 21
}